export enum LD_ContextKinds {
  USER = 'user',
}

export enum LD_ContextRoles {
  SUPER_ADMIN = 'super-admin',
  SYSTEM_USER = 'system-user',
}

export enum LD_FeatureFlags {
  UNDER_CONSTRUCTION = 'under-construction',
  RELEASE_DAILY_FOR_WEB_CALLS = 'release-daily-for-web-calls',
  RELEASE_KNOWLEDGE_HUB = 'release-knowledge-hub',
  RELEASE_REAL_CALLS = 'release-real-calls',
  RELEASE_FULL_SCREEN_CALLS = 'release-full-screen-calls',
  RELEASE_COACHING_RUBRICS = 'release-coaching-rubrics',
  RELEASE_SALESLOFT_INTEGRATION = 'release-salesloft-integration',
}
